import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-edit"
  }, [_c('p', {
    staticClass: "card-description mx-2",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.text'))
    }
  }), _vm.timeTriggers.length === 0 ? [_c(VBtn, {
    class: 'v-btn-x px-3 mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('add-time-trigger', 0);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.addButton')) + "\n    ")], 1)] : [_c(VSwitch, {
    staticClass: "mx-2 mb-2",
    attrs: {
      "inset": "",
      "color": _vm.color,
      "disabled": _vm.disabled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.timeTriggerOnly'),
      "hide-details": ""
    },
    model: {
      value: _vm.rule.properties.timeTriggerOnly,
      callback: function ($$v) {
        _vm.$set(_vm.rule.properties, "timeTriggerOnly", $$v);
      },
      expression: "rule.properties.timeTriggerOnly"
    }
  }), _c('p', {
    staticClass: "card-description mx-2"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.timeTriggerOnlyText')) + "\n    ")]), _vm._l(_vm.timeTriggers, function (timeTrigger, i) {
    return _c('core-n20Card', {
      key: `timetrigger_${i}`,
      class: `dt-card-text-01 ${i === 0 ? 'mt-14' : ''}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [!_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "disabled": _vm.disabled,
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('delete-time-trigger', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "disabled": _vm.disabled,
              "color": _vm.color,
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.addButton'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('add-time-trigger', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, {
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "3"
      }
    }, [_c('core-timezone-selector', {
      attrs: {
        "disabled": _vm.disabled,
        "rules": _vm.requiredRule,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.timeZone'),
        "required": ""
      },
      model: {
        value: timeTrigger.timeZone,
        callback: function ($$v) {
          _vm.$set(timeTrigger, "timeZone", $$v);
        },
        expression: "timeTrigger.timeZone"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "3"
      }
    }, [_c(VSwitch, {
      staticClass: "mt-0 mb-4",
      attrs: {
        "disabled": _vm.disabled,
        "false-value": false,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourly'),
        "hint": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourlyText'),
        "persistent-hint": "",
        "inset": ""
      },
      on: {
        "change": e => {
          if (e === true) {
            timeTrigger.time.hourly = 1;
          }
          _vm.refreshTimeTriggers();
        }
      },
      model: {
        value: timeTrigger.time.hourly,
        callback: function ($$v) {
          _vm.$set(timeTrigger.time, "hourly", $$v);
        },
        expression: "timeTrigger.time.hourly"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "3"
      }
    }, [timeTrigger.time.hourly ? _c(VTextField, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hourlyNumber'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.hourRuleEveryX,
        "type": "number",
        "required": "",
        "hide-details": "auto"
      },
      on: {
        "input": e => {
          timeTrigger.time.hourly = parseInt(e);
        }
      },
      model: {
        value: timeTrigger.time.hourly,
        callback: function ($$v) {
          _vm.$set(timeTrigger.time, "hourly", $$v);
        },
        expression: "timeTrigger.time.hourly"
      }
    }) : _c(VTextField, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.hour'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "rules": _vm.hourRules,
        "type": "number",
        "required": "",
        "hide-details": "auto"
      },
      on: {
        "input": e => {
          timeTrigger.time.hour = parseInt(e);
        }
      },
      model: {
        value: timeTrigger.time.hour,
        callback: function ($$v) {
          _vm.$set(timeTrigger.time, "hour", $$v);
        },
        expression: "timeTrigger.time.hour"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "3"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "disabled": _vm.disabled,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.minute'),
        "rules": _vm.minuteRules,
        "type": "number",
        "required": "",
        "hide-details": "auto"
      },
      on: {
        "input": e => {
          timeTrigger.time.minute = parseInt(e);
        }
      },
      model: {
        value: timeTrigger.time.minute,
        callback: function ($$v) {
          _vm.$set(timeTrigger.time, "minute", $$v);
        },
        expression: "timeTrigger.time.minute"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "card-description",
      domProps: {
        "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.filterText'))
      }
    })]), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSelect, {
      attrs: {
        "disabled": _vm.disabled,
        "items": [{
          value: 1,
          text: _vm.$i18n_t('Common.Monday')
        }, {
          value: 2,
          text: _vm.$i18n_t('Common.Tuesday')
        }, {
          value: 3,
          text: _vm.$i18n_t('Common.Wednesday')
        }, {
          value: 4,
          text: _vm.$i18n_t('Common.Thursday')
        }, {
          value: 5,
          text: _vm.$i18n_t('Common.Friday')
        }, {
          value: 6,
          text: _vm.$i18n_t('Common.Saturday')
        }, {
          value: 0,
          text: _vm.$i18n_t('Common.Sunday')
        }],
        "label": _vm.$i18n_t('Common.WeekDay'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "multiple": "",
        "chips": "",
        "hide-details": ""
      },
      model: {
        value: timeTrigger.weekDays,
        callback: function ($$v) {
          _vm.$set(timeTrigger, "weekDays", $$v);
        },
        expression: "timeTrigger.weekDays"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c(VSelect, {
      attrs: {
        "disabled": _vm.disabled,
        "items": Array.from({
          length: 31
        }, (idx, i) => i + 1),
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.monthDays'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "multiple": "",
        "chips": "",
        "hide-details": ""
      },
      model: {
        value: timeTrigger.monthDays,
        callback: function ($$v) {
          _vm.$set(timeTrigger, "monthDays", $$v);
        },
        expression: "timeTrigger.monthDays"
      }
    })], 1), _c(VCol, {
      staticClass: "px-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('core-dateTime-picker', {
      attrs: {
        "disabled": _vm.disabled,
        "from": new Date(timeTrigger.dateStart) / 1000,
        "timeZone": timeTrigger.timeZone,
        "expandIcon": "",
        "allowNull": "",
        "dateOnly": "",
        "futureRange": "",
        "hideBorderOnCollapse": ""
      },
      on: {
        "date:picked": e => _vm.startDatePicked(e, i)
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function ({
          startDate
        }) {
          return [_c(VTextField, {
            attrs: {
              "value": startDate,
              "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.startDate'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "append-icon": "fal fa-calendar-day",
              "readonly": "",
              "disabled": "",
              "hide-details": ""
            }
          })];
        }
      }], null, true)
    })], 1), _c(VCol, {
      staticClass: "px-0",
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('core-dateTime-picker', {
      attrs: {
        "disabled": _vm.disabled,
        "from": new Date(timeTrigger.dateEnd) / 1000,
        "timeZone": timeTrigger.timeZone,
        "expandIcon": "",
        "allowNull": "",
        "dateOnly": "",
        "futureRange": "",
        "hideBorderOnCollapse": ""
      },
      on: {
        "date:picked": e => _vm.endDatePicked(e, i)
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function ({
          startDate
        }) {
          return [_c(VTextField, {
            attrs: {
              "value": startDate,
              "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.timeTriggers.endDate'),
              "color": _vm.color,
              "outlined": _vm.inpOutlined,
              "filled": _vm.inpFilled,
              "append-icon": "fal fa-calendar-day",
              "readonly": "",
              "disabled": "",
              "hide-details": ""
            }
          })];
        }
      }], null, true)
    })], 1)], 1)], 1);
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };